import React from 'react';
import { Popover, Paper } from '@mui/material';
import { CloseOutlinedIcon } from '../../../../assets/mui';

type DaySelectorDialogProps = {
  open: boolean;
  onClose: () => void;
  selectedDay: string;
  onSelectDay: (day: string) => void;
  title?: string;
  subtitle?: string;
  anchorEl?: HTMLElement | null;
};

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const DaySelectorDialog: React.FC<DaySelectorDialogProps> = ({
  open,
  onClose,
  selectedDay,
  onSelectDay,
  title = 'Select Debit Day',
  subtitle = 'Autopay begins on the selected day',
  anchorEl,
}) => {
  const handleDaySelect = (day: string) => {
    onSelectDay(day);
    onClose();
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          borderRadius: '12px 12px 0 0 !important',
          maxWidth: '200px',
          width: anchorEl ? `${Math.max(anchorEl.getBoundingClientRect().width, 120)}px` : '120px',
          maxHeight: '60vh',
          mt: 0.5,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
        },
      }}
      slotProps={{
        paper: {
          sx: {
            overflow: 'visible',
          },
        },
      }}
    >
      <Paper sx={{ p: 0, overflow: 'hidden' }}>
        {/* Header */}
        <div className="px-3 py-2 border-b border-stone-200">
          <div className="flex justify-between items-center">
            <div className="flex-1 text-center">
              <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
              <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>
            </div>
            <CloseOutlinedIcon
              className="cursor-pointer bg-slate-200 rounded-full p-0.5"
              onClick={onClose}
              style={{
                width: '24px',
                height: '24px',
              }}
            />
          </div>
        </div>

        {/* Content */}
        <div className="py-1.5 overflow-y-auto" style={{ maxHeight: 'calc(60vh - 80px)' }}>
          {daysOfWeek.map((day) => {
            const isSelected = selectedDay === day;
            return (
              <button
                key={day}
                type="button"
                onClick={() => handleDaySelect(day)}
                className={`
                  w-full px-3 py-2 text-left text-xs font-medium transition
                  ${isSelected ? 'bg-slate-100 text-slate-800' : 'text-slate-600 hover:bg-slate-50'}
                `}
              >
                {day}
              </button>
            );
          })}
        </div>
      </Paper>
    </Popover>
  );
};

export default DaySelectorDialog;
